import React from 'react';
import { connect } from 'react-redux';
import { shareAnswerKey } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  shareAnswerKey,
};

function ModalShareAnswerKey({ shareAnswerKey, data, closeModal }) {
  const auth = data?.auth;
  const item = data?.item;
  const id = item?.id;
  const isStudentAnswered = item?.isStudentAnswered;
  const history = data?.history;
  const screenWidth = useScreenWidth();

  function handleShare() {
    shareAnswerKey({ auth, history, id, values: item });
    closeModal();
  }

  return (
    <Modal
      variant='info'
      label='Publish'
      closeModal={closeModal}
      width={screenWidth > 600 ? 600 : screenWidth}
    >
      <div className='flex justify-around flex-column align-start mx-5 mb-4'>
        {!isStudentAnswered && (
          <p className='mt-5 has-text-danger  has-text-centered'>
            Siswa belum mengerjakan{' '}
            <span className='has-text-weight-bold'>Tes</span>!
          </p>
        )}
        <p className={`is-size-6 mb-3${isStudentAnswered ? ' mt-5' : ''}`}>
          Apakah Anda yakin ingin membagikan kunci jawaban{' '}
          <span className='has-text-info has-text-weight-semibold'>{`${item.title}`}</span>
          ?
        </p>
      </div>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={() => handleShare(data)} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalShareAnswerKey);
